module.exports = {
          srcSet: __webpack_public_path__ + "32edd15b8003e094bbf35d30e2bb6f41-595.png"+" 595w",
          images:[ {path: __webpack_public_path__ + "32edd15b8003e094bbf35d30e2bb6f41-595.png",width: 595,height: 398}],
          src: __webpack_public_path__ + "32edd15b8003e094bbf35d30e2bb6f41-595.png",
          toString:function(){return __webpack_public_path__ + "32edd15b8003e094bbf35d30e2bb6f41-595.png"},
          
          width: 595,
          height: 398
        }